// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "0fb70abeedb1346f","396": "1125b86c1d8db4d8","460": "a673675e1476137c","917": "fe2d9ed9078ce142","985": "2fcddb8b8441efe9",}[chunkId] + ".chunk.js"
}